// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"LabsInboxSettingsContainer_checkboxContainer__+flgD","checkboxDescription":"LabsInboxSettingsContainer_checkboxDescription__foIAb"};